<!-- 产品分类统计 -->
<template>
  <div class="classify-ring">
    <h-title :text="'产品分类统计'"></h-title>
    <ve-ring
      class="ring"
      :data="chartData"
      width="360px"
      height="160px"
      :settings="chartSettings"
      :extend="chartExtend"
    ></ve-ring>
  </div>
</template>

<script>
import HTitle from '@/components/common/hTitle'
export default {
  data () {
    this.chartSettings = {
      dimension: 'name',
      metrics: 'value',
      radius: [
        '35', '50'
      ],
      offsetY: 80,
      labelLine: {
        normal: {
          lineStyle: {
            color: '#fff'
          }
        }
      },
      label: {
        normal: {
          formatter: '{b}: {d}%',
          padding: [0, -10]
        }
      }
    }
    return {
      chartExtend: {
        legend: {
          show: false
        }
      }
    }
  },
  components: {
    HTitle
  },
  props: {
    chartData: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang='stylus' scoped>
.classify-ring
  width 368px
  // box-shadow 0px 0px 20px 0px #3dbdc4
  border-radius 8px
  border 1px solid #3DBDC4
  background #0C1530
  padding-bottom 20px
  .ring
    margin-left 4px
</style>



// WEBPACK FOOTER //
// src/components/common/classifyRing.vue